// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyB1jdba0iH6POaU-oZs75Mj16NwvImNmIQ',
  authDomain: 'jose-portfolio-474ce.firebaseapp.com',
  projectId: 'jose-portfolio-474ce',
  storageBucket: 'jose-portfolio-474ce.appspot.com',
  messagingSenderId: '351441851372',
  appId: '1:351441851372:web:a22f379543d3dd4e3f66c9',
  measurementId: 'G-QS81B9BTLB',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };
